/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled'
import React from 'react'
import colors from '@sportninja/common/constants/appColors'
import { InfoCircleOutlined, PlayCircleOutlined } from '@ant-design/icons'

const BannerContainer = styled.div`
  background: ${colors.PRIMARY_50};
  border: 1px solid ${colors.PRIMARY_100};
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`

const TopContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`

const IconContainer = styled.div`
  color: ${colors.PRIMARY_400};
  font-size: 20px;
  display: flex;
  align-items: center;
`

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.SECONDARY_400};
`

const Description = styled.div`
  font-size: 12px;
  color: ${colors.SECONDARY_300};
`

const ContinueButton = styled.button`
  background: ${colors.PRIMARY};
  color: ${colors.NEUTRAL_0};
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background-color 0.2s ease;
  width: 100%;

  &:hover {
    background: ${colors.PRIMARY_400};
  }

  &:active {
    background: ${colors.PRIMARY_500};
  }
`

interface ContinueTutorialBannerProps {
  onContinue: () => void
}

/**
 * Banner component displayed in the sidebar when the onboarding tutorial is skipped
 * Allows users to resume the tutorial setup wizard
 */
const ContinueTutorialBanner: React.FC<ContinueTutorialBannerProps> = ({
  onContinue,
}) => {
  console.log('🔄 ContinueTutorialBanner: Rendering banner')

  return (
    <BannerContainer>
      <TopContent>
        <IconContainer>
          <InfoCircleOutlined />
        </IconContainer>
        <ContentContainer>
          <Title>Complete Your Setup</Title>
          <Description>
            Continue where you left off with the setup wizard
          </Description>
        </ContentContainer>
      </TopContent>
      <ContinueButton onClick={onContinue}>
        <PlayCircleOutlined />
        Continue
      </ContinueButton>
    </BannerContainer>
  )
}

export default ContinueTutorialBanner
